'use client'

import {Calendar as AntdCalendar, type CalendarProps} from 'antd'
import ruLocale from 'antd/es/calendar/locale/ru_RU'
import dayjs, {type Dayjs} from 'dayjs'
import 'dayjs/locale/ru'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(updateLocale)
dayjs.updateLocale('ru', {
  weekStart: 1,
})

const calendarLocale = {
  ...ruLocale,
  lang: {
    ...ruLocale.lang,
    shortMonths: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
  },
}

export const Calendar = ({locale, ...props}: CalendarProps<Dayjs>) => (
  <AntdCalendar locale={locale ?? calendarLocale} {...props} />
)
